define([
	"dojo/_base/declare",
	"csi",
	"csi/action/FreezeController"
], function(declare,csi,FreezeController) {

	return declare(FreezeController, {
		preProcess: function() {
			// summary: do not allow action if sales order lacks buyer, customer, or line item
			// make sure to get the latest version of the node
			var node = this.getNode();
			if (node.Seller == csi.EMPTY_URL || node.Buyer == csi.EMPTY_URL || node.LineItems.length < 1) {
				this.displayErrorDialog({suffix:"_ErrorInvalidFreeze"});
			} else {
				this.inherited(arguments);
			}
		},

		postProcessSuccess: function() {
			// summary: refresh line items table
			var	v = this.widget.viewParent.getChildView("LineItems") || this.widget.viewParent.getChildView("LineItemsSKU");
			if (v) {
				v.cacheView.put(this.getNode());
				v.refreshWidget();
			}

			this.inherited(arguments);
		}
	});
});
